import styled, { css } from 'styled-components';
import { StyledBadge } from '@/components/Badge/styles';
import { breakpoints } from '@/styles/breakpoints';

const StyledTypes = styled.div`
  display: flex;

  ${breakpoints.MD} {
    margin-top: ${({ theme }) => theme.spacings.x3};
  }

  ${breakpoints.MDL} {
    margin-top: 18px;
    width: 107%;
  }

  ${breakpoints.LG} {
    padding-left: 5px;
  }
`;

interface TypeProps {
  active: boolean;
}

const Type = styled.button<TypeProps>`
  display: flex;
  align-items: center;
  font-weight: 400;
  position: relative;

  & + & {
    margin-left: ${({ theme }) => theme.spacings.x5};

    &:before {
      content: '';
      position: absolute;
      width: 2px;
      height: 24px;
      left: -19px;
      top: 50%;
      background: ${({ theme }) => theme.colors.divider};
      transform: rotate(-13.19deg) translateY(-50%);
    }
  }

  ${StyledBadge} {
    padding: 2px 11px;
  }

  ${({ theme, active }) =>
    active &&
    css`
      color: ${theme.colors.primary.first};

      &:hover {
        color: ${theme.colors.primary.first};
      }
    `}
`;

const Label = styled.div`
  font-size: 16px;
  line-height: 22px;
  text-transform: none;

  ${breakpoints.MD} {
    font-size: 24px;
    line-height: 32px;
  }
`;

const Counter = styled.div`
  margin-left: ${({ theme }) => theme.spacings.base};
`;

export { StyledTypes, Type, Label, Counter };
